// stored in the db, don't remove any values or change existing values
export var LobbyImage = /*#__PURE__*/ function(LobbyImage) {
    LobbyImage[LobbyImage["Pencil"] = 0] = "Pencil";
    LobbyImage[LobbyImage["Bot"] = 1] = "Bot";
    LobbyImage[LobbyImage["CheckMark"] = 2] = "CheckMark";
    LobbyImage[LobbyImage["XMark"] = 3] = "XMark";
    LobbyImage[LobbyImage["Logo"] = 4] = "Logo";
    LobbyImage[LobbyImage["Lightning"] = 5] = "Lightning";
    LobbyImage[LobbyImage["Plus"] = 6] = "Plus";
    LobbyImage[LobbyImage["PlusStore"] = 7] = "PlusStore";
    LobbyImage[LobbyImage["Mail"] = 8] = "Mail";
    LobbyImage[LobbyImage["Admin"] = 9] = "Admin";
    LobbyImage[LobbyImage["Moderator"] = 10] = "Moderator";
    LobbyImage[LobbyImage["User"] = 11] = "User";
    LobbyImage[LobbyImage["Guest"] = 12] = "Guest";
    LobbyImage[LobbyImage["Star"] = 13] = "Star";
    LobbyImage[LobbyImage["Players"] = 14] = "Players";
    LobbyImage[LobbyImage["PlayersRanked"] = 285] = "PlayersRanked";
    LobbyImage[LobbyImage["ReplayIcon"] = 15] = "ReplayIcon";
    LobbyImage[LobbyImage["QuestionMark"] = 16] = "QuestionMark";
    LobbyImage[LobbyImage["InfoIcon"] = 17] = "InfoIcon";
    LobbyImage[LobbyImage["DangerIcon"] = 18] = "DangerIcon";
    LobbyImage[LobbyImage["KarmaWhite"] = 19] = "KarmaWhite";
    LobbyImage[LobbyImage["KarmaRed"] = 20] = "KarmaRed";
    LobbyImage[LobbyImage["KarmaOrange"] = 21] = "KarmaOrange";
    LobbyImage[LobbyImage["KarmaGreen"] = 22] = "KarmaGreen";
    LobbyImage[LobbyImage["DisableAdBlock"] = 23] = "DisableAdBlock";
    LobbyImage[LobbyImage["ColonistCoin"] = 24] = "ColonistCoin";
    LobbyImage[LobbyImage["Rulebook"] = 25] = "Rulebook";
    LobbyImage[LobbyImage["BankIcon"] = 26] = "BankIcon";
    LobbyImage[LobbyImage["FullScreenExpand"] = 27] = "FullScreenExpand";
    LobbyImage[LobbyImage["FullScreenContract"] = 28] = "FullScreenContract";
    LobbyImage[LobbyImage["FullScreenGif"] = 29] = "FullScreenGif";
    LobbyImage[LobbyImage["LeftArrow"] = 30] = "LeftArrow";
    LobbyImage[LobbyImage["Audio"] = 31] = "Audio";
    LobbyImage[LobbyImage["Eye"] = 32] = "Eye";
    LobbyImage[LobbyImage["SendArrow"] = 33] = "SendArrow";
    LobbyImage[LobbyImage["Settings"] = 34] = "Settings";
    LobbyImage[LobbyImage["Chat"] = 35] = "Chat";
    LobbyImage[LobbyImage["Log"] = 36] = "Log";
    LobbyImage[LobbyImage["MatchmakingSearch"] = 37] = "MatchmakingSearch";
    LobbyImage[LobbyImage["Lock"] = 38] = "Lock";
    LobbyImage[LobbyImage["LockOutlined"] = 39] = "LockOutlined";
    LobbyImage[LobbyImage["LockSlanted"] = 40] = "LockSlanted";
    LobbyImage[LobbyImage["LockOn"] = 288] = "LockOn";
    LobbyImage[LobbyImage["Share"] = 41] = "Share";
    LobbyImage[LobbyImage["NoAds"] = 246] = "NoAds";
    LobbyImage[LobbyImage["Colors"] = 247] = "Colors";
    LobbyImage[LobbyImage["Avatars"] = 261] = "Avatars";
    LobbyImage[LobbyImage["Maps"] = 262] = "Maps";
    LobbyImage[LobbyImage["Expansions"] = 263] = "Expansions";
    LobbyImage[LobbyImage["AllColors"] = 264] = "AllColors";
    LobbyImage[LobbyImage["Memberships"] = 267] = "Memberships";
    LobbyImage[LobbyImage["RoadBronze"] = 42] = "RoadBronze";
    LobbyImage[LobbyImage["SettlementBronze"] = 43] = "SettlementBronze";
    LobbyImage[LobbyImage["CityBronze"] = 44] = "CityBronze";
    // Maps
    LobbyImage[LobbyImage["MapDiamondPreview"] = 45] = "MapDiamondPreview";
    LobbyImage[LobbyImage["MapLakesPreview"] = 46] = "MapLakesPreview";
    LobbyImage[LobbyImage["MapPondPreview"] = 47] = "MapPondPreview";
    LobbyImage[LobbyImage["MapGearPreview"] = 48] = "MapGearPreview";
    LobbyImage[LobbyImage["MapUSAPreview"] = 49] = "MapUSAPreview";
    LobbyImage[LobbyImage["MapTwirlPreview"] = 50] = "MapTwirlPreview";
    LobbyImage[LobbyImage["MapEarthPreview"] = 51] = "MapEarthPreview";
    LobbyImage[LobbyImage["MapUKPreview"] = 52] = "MapUKPreview";
    LobbyImage[LobbyImage["MapCyclopsPreview"] = 53] = "MapCyclopsPreview";
    LobbyImage[LobbyImage["MapClassic4PPreview"] = 54] = "MapClassic4PPreview";
    LobbyImage[LobbyImage["MapClassic56PPreview"] = 55] = "MapClassic56PPreview";
    LobbyImage[LobbyImage["MapClassic78PPreview"] = 56] = "MapClassic78PPreview";
    LobbyImage[LobbyImage["MapPangaeaPreview"] = 57] = "MapPangaeaPreview";
    LobbyImage[LobbyImage["MapSpinnerPreview"] = 58] = "MapSpinnerPreview";
    LobbyImage[LobbyImage["MapRandomBasePreview"] = 59] = "MapRandomBasePreview";
    LobbyImage[LobbyImage["MapRomaniaPreview"] = 60] = "MapRomaniaPreview";
    LobbyImage[LobbyImage["MapHourglassPreview"] = 61] = "MapHourglassPreview";
    LobbyImage[LobbyImage["MapHourglassXLPreview"] = 62] = "MapHourglassXLPreview";
    LobbyImage[LobbyImage["MapSnowflakePreview"] = 63] = "MapSnowflakePreview";
    LobbyImage[LobbyImage["MapShuffleBoardPreview"] = 64] = "MapShuffleBoardPreview";
    LobbyImage[LobbyImage["MapMiniBasePreview"] = 65] = "MapMiniBasePreview";
    LobbyImage[LobbyImage["MapAustraliaPreview"] = 66] = "MapAustraliaPreview";
    LobbyImage[LobbyImage["MapDuelPreview"] = 67] = "MapDuelPreview";
    LobbyImage[LobbyImage["MapMonopolyPreview"] = 68] = "MapMonopolyPreview";
    LobbyImage[LobbyImage["MapKingOfTheHillPreview"] = 69] = "MapKingOfTheHillPreview";
    LobbyImage[LobbyImage["MapMountainOfRichesPreview"] = 70] = "MapMountainOfRichesPreview";
    LobbyImage[LobbyImage["MapDoggoPreview"] = 71] = "MapDoggoPreview";
    LobbyImage[LobbyImage["MapTradeIslandsPreview"] = 72] = "MapTradeIslandsPreview";
    LobbyImage[LobbyImage["MapTurningTidesPreview"] = 73] = "MapTurningTidesPreview";
    LobbyImage[LobbyImage["MapBlackForestPreview"] = 74] = "MapBlackForestPreview";
    LobbyImage[LobbyImage["MapVolcanoPreview"] = 75] = "MapVolcanoPreview";
    LobbyImage[LobbyImage["MapCirclePreview"] = 76] = "MapCirclePreview";
    LobbyImage[LobbyImage["MapKitePreview"] = 77] = "MapKitePreview";
    LobbyImage[LobbyImage["MapVietnamPreview"] = 78] = "MapVietnamPreview";
    LobbyImage[LobbyImage["MapTwoIslesPreview"] = 79] = "MapTwoIslesPreview";
    LobbyImage[LobbyImage["MapJellyFishPreview"] = 80] = "MapJellyFishPreview";
    LobbyImage[LobbyImage["MapGoldRushPreview"] = 81] = "MapGoldRushPreview";
    LobbyImage[LobbyImage["MapIstanbulPreview"] = 82] = "MapIstanbulPreview";
    LobbyImage[LobbyImage["MapEuropePreview"] = 83] = "MapEuropePreview";
    LobbyImage[LobbyImage["MapStripesPreview"] = 84] = "MapStripesPreview";
    LobbyImage[LobbyImage["MapMonopolyIslandsPreview"] = 85] = "MapMonopolyIslandsPreview";
    LobbyImage[LobbyImage["MapSS1HeadingForNewShores3PPreview"] = 86] = "MapSS1HeadingForNewShores3PPreview";
    LobbyImage[LobbyImage["MapSS1HeadingForNewShores4PPreview"] = 87] = "MapSS1HeadingForNewShores4PPreview";
    LobbyImage[LobbyImage["MapSS1HeadingForNewShores56PPreview"] = 88] = "MapSS1HeadingForNewShores56PPreview";
    LobbyImage[LobbyImage["MapSS2FourIslands3PPreview"] = 89] = "MapSS2FourIslands3PPreview";
    LobbyImage[LobbyImage["MapSS2FourIslands4PPreview"] = 90] = "MapSS2FourIslands4PPreview";
    LobbyImage[LobbyImage["MapSS2SixIslands56PPreview"] = 91] = "MapSS2SixIslands56PPreview";
    LobbyImage[LobbyImage["MapSS3FogIslands3PPreview"] = 92] = "MapSS3FogIslands3PPreview";
    LobbyImage[LobbyImage["MapSS3FogIslands4PPreview"] = 93] = "MapSS3FogIslands4PPreview";
    LobbyImage[LobbyImage["MapSS3FogIslands56PPreview"] = 94] = "MapSS3FogIslands56PPreview";
    LobbyImage[LobbyImage["MapSS4ThroughTheDesert3PPreview"] = 95] = "MapSS4ThroughTheDesert3PPreview";
    LobbyImage[LobbyImage["MapSS4ThroughTheDesert4PPreview"] = 96] = "MapSS4ThroughTheDesert4PPreview";
    LobbyImage[LobbyImage["MapSS4ThroughTheDesert56PPreview"] = 97] = "MapSS4ThroughTheDesert56PPreview";
    LobbyImage[LobbyImage["GameMode1v1"] = 98] = "GameMode1v1";
    LobbyImage[LobbyImage["GameModeBase"] = 99] = "GameModeBase";
    LobbyImage[LobbyImage["GameModeBase56P"] = 250] = "GameModeBase56P";
    LobbyImage[LobbyImage["GameModeBase78P"] = 251] = "GameModeBase78P";
    LobbyImage[LobbyImage["GameModeSeafarers"] = 252] = "GameModeSeafarers";
    LobbyImage[LobbyImage["GameModeSeafarers56P"] = 253] = "GameModeSeafarers56P";
    LobbyImage[LobbyImage["GameModeCnK"] = 100] = "GameModeCnK";
    LobbyImage[LobbyImage["GameModeCitiesAndKnights56P"] = 254] = "GameModeCitiesAndKnights56P";
    LobbyImage[LobbyImage["GameModeCnKSeafarers"] = 248] = "GameModeCnKSeafarers";
    LobbyImage[LobbyImage["GameModeSeafarersCitiesAndKnights56P"] = 255] = "GameModeSeafarersCitiesAndKnights56P";
    LobbyImage[LobbyImage["GameModeColonistRush"] = 270] = "GameModeColonistRush";
    /**
     * @deprecated use GameModeBase instead
     * Remove enum once LobbyImage enums can be removed
     */ LobbyImage[LobbyImage["GameModeBasePreview"] = 101] = "GameModeBasePreview";
    // Memberships
    LobbyImage[LobbyImage["StoreMembershipPlus"] = 102] = "StoreMembershipPlus";
    LobbyImage[LobbyImage["StoreMembershipPremium"] = 103] = "StoreMembershipPremium";
    LobbyImage[LobbyImage["StoreMembershipElite"] = 104] = "StoreMembershipElite";
    LobbyImage[LobbyImage["StoreMembershipHoliday2023"] = 105] = "StoreMembershipHoliday2023";
    // Membership Perks
    LobbyImage[LobbyImage["StoreMembershipPerkAllMaps"] = 106] = "StoreMembershipPerkAllMaps";
    LobbyImage[LobbyImage["StoreMembershipPerkAllExpansions"] = 107] = "StoreMembershipPerkAllExpansions";
    LobbyImage[LobbyImage["StoreMembershipPerkRankedGames"] = 108] = "StoreMembershipPerkRankedGames";
    LobbyImage[LobbyImage["StoreMembershipPerkCustomLinks"] = 109] = "StoreMembershipPerkCustomLinks";
    LobbyImage[LobbyImage["StoreMembershipPerkColonistCoins"] = 110] = "StoreMembershipPerkColonistCoins";
    LobbyImage[LobbyImage["StoreMembershipPerkNoAds"] = 111] = "StoreMembershipPerkNoAds";
    LobbyImage[LobbyImage["StoreMembershipPerkNoAdsGifDesertBox"] = 112] = "StoreMembershipPerkNoAdsGifDesertBox";
    LobbyImage[LobbyImage["StoreMembershipPerkNoAdsGifGoldBox"] = 113] = "StoreMembershipPerkNoAdsGifGoldBox";
    LobbyImage[LobbyImage["StoreMembershipPerkNoAdsGifDesertHex"] = 114] = "StoreMembershipPerkNoAdsGifDesertHex";
    LobbyImage[LobbyImage["StoreMembershipPerkNoAdsGifGoldHex"] = 115] = "StoreMembershipPerkNoAdsGifGoldHex";
    LobbyImage[LobbyImage["StoreMembershipPerkAllColors"] = 116] = "StoreMembershipPerkAllColors";
    // Expansions
    LobbyImage[LobbyImage["StoreItemExpansionClassic56P"] = 117] = "StoreItemExpansionClassic56P";
    LobbyImage[LobbyImage["StoreItemExpansionClassic78P"] = 118] = "StoreItemExpansionClassic78P";
    LobbyImage[LobbyImage["StoreItemSeafarers4P"] = 119] = "StoreItemSeafarers4P";
    LobbyImage[LobbyImage["StoreItemSeafarers56P"] = 120] = "StoreItemSeafarers56P";
    LobbyImage[LobbyImage["StoreItemCitiesAndKnights4P"] = 121] = "StoreItemCitiesAndKnights4P";
    LobbyImage[LobbyImage["StoreItemCitiesAndKnights56P"] = 122] = "StoreItemCitiesAndKnights56P";
    LobbyImage[LobbyImage["StoreItemCitiesAndKnightsSeafarers4P"] = 123] = "StoreItemCitiesAndKnightsSeafarers4P";
    LobbyImage[LobbyImage["StoreItemCitiesAndKnightsSeafarers56P"] = 124] = "StoreItemCitiesAndKnightsSeafarers56P";
    // Colors
    LobbyImage[LobbyImage["StoreColorBlack"] = 125] = "StoreColorBlack";
    LobbyImage[LobbyImage["StoreColorPurple"] = 126] = "StoreColorPurple";
    LobbyImage[LobbyImage["StoreColorMysticBlue"] = 127] = "StoreColorMysticBlue";
    LobbyImage[LobbyImage["StoreColorWhite"] = 128] = "StoreColorWhite";
    LobbyImage[LobbyImage["StoreColorBronze"] = 129] = "StoreColorBronze";
    LobbyImage[LobbyImage["StoreColorSilver"] = 130] = "StoreColorSilver";
    LobbyImage[LobbyImage["StoreColorGold"] = 131] = "StoreColorGold";
    LobbyImage[LobbyImage["StoreColorPink"] = 132] = "StoreColorPink";
    // Icons
    LobbyImage[LobbyImage["IconElephant"] = 133] = "IconElephant";
    LobbyImage[LobbyImage["IconSombrero"] = 134] = "IconSombrero";
    LobbyImage[LobbyImage["IconFarmer"] = 135] = "IconFarmer";
    LobbyImage[LobbyImage["IconAvocado"] = 136] = "IconAvocado";
    LobbyImage[LobbyImage["IconCactus"] = 137] = "IconCactus";
    LobbyImage[LobbyImage["IconCrown"] = 138] = "IconCrown";
    LobbyImage[LobbyImage["IconSwords"] = 139] = "IconSwords";
    LobbyImage[LobbyImage["IconHelmet"] = 140] = "IconHelmet";
    LobbyImage[LobbyImage["IconSnorkel"] = 141] = "IconSnorkel";
    LobbyImage[LobbyImage["IconScarf"] = 142] = "IconScarf";
    LobbyImage[LobbyImage["IconTie"] = 143] = "IconTie";
    LobbyImage[LobbyImage["IconWorker"] = 144] = "IconWorker";
    LobbyImage[LobbyImage["IconMummy"] = 145] = "IconMummy";
    LobbyImage[LobbyImage["IconSettlerHat"] = 146] = "IconSettlerHat";
    LobbyImage[LobbyImage["IconColonistHat"] = 147] = "IconColonistHat";
    LobbyImage[LobbyImage["IconFounderHat"] = 148] = "IconFounderHat";
    LobbyImage[LobbyImage["IconChristmasHat"] = 149] = "IconChristmasHat";
    LobbyImage[LobbyImage["IconPirateShip"] = 150] = "IconPirateShip";
    LobbyImage[LobbyImage["IconMedalGold"] = 151] = "IconMedalGold";
    LobbyImage[LobbyImage["IconMedalSilver"] = 152] = "IconMedalSilver";
    LobbyImage[LobbyImage["IconMedalBronze"] = 153] = "IconMedalBronze";
    LobbyImage[LobbyImage["IconRobberSanta"] = 154] = "IconRobberSanta";
    LobbyImage[LobbyImage["IconRobberLunar"] = 155] = "IconRobberLunar";
    LobbyImage[LobbyImage["IconRobberCupid"] = 156] = "IconRobberCupid";
    LobbyImage[LobbyImage["IconGifter"] = 256] = "IconGifter";
    LobbyImage[LobbyImage["IconNoTroll"] = 258] = "IconNoTroll";
    // Packs
    LobbyImage[LobbyImage["SettlerPack"] = 157] = "SettlerPack";
    LobbyImage[LobbyImage["ColonistPack"] = 158] = "ColonistPack";
    LobbyImage[LobbyImage["FounderPack"] = 159] = "FounderPack";
    // Game icons
    LobbyImage[LobbyImage["Bank"] = 160] = "Bank";
    LobbyImage[LobbyImage["Robber"] = 161] = "Robber";
    LobbyImage[LobbyImage["Dice3Sharp"] = 289] = "Dice3Sharp";
    LobbyImage[LobbyImage["Dice6"] = 162] = "Dice6";
    LobbyImage[LobbyImage["PrivateGame"] = 163] = "PrivateGame";
    LobbyImage[LobbyImage["HideBankCards"] = 164] = "HideBankCards";
    // Roads
    LobbyImage[LobbyImage["RoadRed"] = 165] = "RoadRed";
    LobbyImage[LobbyImage["RoadBlue"] = 166] = "RoadBlue";
    LobbyImage[LobbyImage["RoadGreen"] = 167] = "RoadGreen";
    LobbyImage[LobbyImage["RoadOrange"] = 168] = "RoadOrange";
    LobbyImage[LobbyImage["RoadBlack"] = 169] = "RoadBlack";
    LobbyImage[LobbyImage["RoadSilver"] = 170] = "RoadSilver";
    LobbyImage[LobbyImage["RoadGold"] = 171] = "RoadGold";
    LobbyImage[LobbyImage["RoadWhite"] = 172] = "RoadWhite";
    LobbyImage[LobbyImage["RoadPurple"] = 173] = "RoadPurple";
    LobbyImage[LobbyImage["RoadMysticBlue"] = 174] = "RoadMysticBlue";
    LobbyImage[LobbyImage["RoadPink"] = 175] = "RoadPink";
    // Settlements
    LobbyImage[LobbyImage["SettlementRed"] = 176] = "SettlementRed";
    LobbyImage[LobbyImage["SettlementBlue"] = 177] = "SettlementBlue";
    LobbyImage[LobbyImage["SettlementGreen"] = 178] = "SettlementGreen";
    LobbyImage[LobbyImage["SettlementOrange"] = 179] = "SettlementOrange";
    LobbyImage[LobbyImage["SettlementBlack"] = 180] = "SettlementBlack";
    LobbyImage[LobbyImage["SettlementSilver"] = 181] = "SettlementSilver";
    LobbyImage[LobbyImage["SettlementGold"] = 182] = "SettlementGold";
    LobbyImage[LobbyImage["SettlementWhite"] = 183] = "SettlementWhite";
    LobbyImage[LobbyImage["SettlementPurple"] = 184] = "SettlementPurple";
    LobbyImage[LobbyImage["SettlementMysticBlue"] = 185] = "SettlementMysticBlue";
    LobbyImage[LobbyImage["SettlementPink"] = 186] = "SettlementPink";
    // Cities
    LobbyImage[LobbyImage["CityRed"] = 187] = "CityRed";
    LobbyImage[LobbyImage["CityBlue"] = 188] = "CityBlue";
    LobbyImage[LobbyImage["CityGreen"] = 189] = "CityGreen";
    LobbyImage[LobbyImage["CityOrange"] = 190] = "CityOrange";
    LobbyImage[LobbyImage["CityBlack"] = 191] = "CityBlack";
    LobbyImage[LobbyImage["CitySilver"] = 192] = "CitySilver";
    LobbyImage[LobbyImage["CityGold"] = 193] = "CityGold";
    LobbyImage[LobbyImage["CityWhite"] = 194] = "CityWhite";
    LobbyImage[LobbyImage["CityPurple"] = 195] = "CityPurple";
    LobbyImage[LobbyImage["CityMysticBlue"] = 196] = "CityMysticBlue";
    LobbyImage[LobbyImage["CityPink"] = 197] = "CityPink";
    // Coin Stacks
    LobbyImage[LobbyImage["CoinStack1"] = 198] = "CoinStack1";
    LobbyImage[LobbyImage["CoinStack2"] = 199] = "CoinStack2";
    LobbyImage[LobbyImage["CoinStack3"] = 200] = "CoinStack3";
    LobbyImage[LobbyImage["CoinStack4"] = 201] = "CoinStack4";
    LobbyImage[LobbyImage["CoinStack5"] = 202] = "CoinStack5";
    LobbyImage[LobbyImage["CoinStack6"] = 203] = "CoinStack6";
    // Friends
    LobbyImage[LobbyImage["Friends"] = 204] = "Friends";
    LobbyImage[LobbyImage["AddFriend"] = 266] = "AddFriend";
    // Login
    LobbyImage[LobbyImage["GoogleIcon"] = 205] = "GoogleIcon";
    LobbyImage[LobbyImage["AppleIcon"] = 206] = "AppleIcon";
    LobbyImage[LobbyImage["DiscordIcon"] = 207] = "DiscordIcon";
    LobbyImage[LobbyImage["FacebookIcon"] = 208] = "FacebookIcon";
    // Rank divisions
    LobbyImage[LobbyImage["RankBronze"] = 209] = "RankBronze";
    LobbyImage[LobbyImage["RankSilver"] = 210] = "RankSilver";
    LobbyImage[LobbyImage["RankGold"] = 211] = "RankGold";
    LobbyImage[LobbyImage["RankPlatinum"] = 212] = "RankPlatinum";
    LobbyImage[LobbyImage["RankDiamond"] = 213] = "RankDiamond";
    LobbyImage[LobbyImage["RankMaster"] = 214] = "RankMaster";
    LobbyImage[LobbyImage["RankGrandmaster"] = 215] = "RankGrandmaster";
    LobbyImage[LobbyImage["RankSubdivisionI"] = 216] = "RankSubdivisionI";
    LobbyImage[LobbyImage["RankSubdivisionII"] = 217] = "RankSubdivisionII";
    LobbyImage[LobbyImage["RankSubdivisionIII"] = 218] = "RankSubdivisionIII";
    LobbyImage[LobbyImage["RankSubdivisionIV"] = 219] = "RankSubdivisionIV";
    LobbyImage[LobbyImage["RankSubdivisionV"] = 220] = "RankSubdivisionV";
    // Mobile
    /**
     * @deprecated Layout orientation features removed
     * Remove enum once LobbyImage enums can be removed
    */ LobbyImage[LobbyImage["LandscapeIcon"] = 221] = "LandscapeIcon";
    /**
     * @deprecated Layout orientation features removed
     * Remove enum once LobbyImage enums can be removed
   */ LobbyImage[LobbyImage["PortraitIcon"] = 222] = "PortraitIcon";
    // ColonistPack, RoadColonist, CityColonist,
    // FounderPack, RoadFounder, CityFounder,
    // RoadRed, CityRed,
    // RoadBlue, CityBlue,
    // RoadGreen, CityGreen,
    // RoadOrange, CityOrange,
    LobbyImage[LobbyImage["RewindToStart"] = 223] = "RewindToStart";
    LobbyImage[LobbyImage["Rewind"] = 224] = "Rewind";
    LobbyImage[LobbyImage["Play"] = 225] = "Play";
    LobbyImage[LobbyImage["Pause"] = 226] = "Pause";
    LobbyImage[LobbyImage["FastForward"] = 227] = "FastForward";
    LobbyImage[LobbyImage["FastForwardToEnd"] = 228] = "FastForwardToEnd";
    LobbyImage[LobbyImage["X05"] = 229] = "X05";
    LobbyImage[LobbyImage["X1"] = 230] = "X1";
    LobbyImage[LobbyImage["X2"] = 231] = "X2";
    LobbyImage[LobbyImage["X4"] = 232] = "X4";
    LobbyImage[LobbyImage["X8"] = 233] = "X8";
    LobbyImage[LobbyImage["DownArrowBlack"] = 265] = "DownArrowBlack";
    LobbyImage[LobbyImage["DownArrow"] = 234] = "DownArrow";
    LobbyImage[LobbyImage["UpArrow"] = 235] = "UpArrow";
    LobbyImage[LobbyImage["OutArrow"] = 286] = "OutArrow";
    LobbyImage[LobbyImage["LongestRoad"] = 236] = "LongestRoad";
    LobbyImage[LobbyImage["LargestArmy"] = 237] = "LargestArmy";
    LobbyImage[LobbyImage["CardMonopoly"] = 238] = "CardMonopoly";
    LobbyImage[LobbyImage["CardVictoryPoint"] = 239] = "CardVictoryPoint";
    // Profile
    LobbyImage[LobbyImage["ProfileOverview"] = 240] = "ProfileOverview";
    LobbyImage[LobbyImage["ProfileRanked"] = 241] = "ProfileRanked";
    LobbyImage[LobbyImage["ProfileHistory"] = 242] = "ProfileHistory";
    LobbyImage[LobbyImage["ProfileItems"] = 243] = "ProfileItems";
    LobbyImage[LobbyImage["ProfileMemberships"] = 269] = "ProfileMemberships";
    LobbyImage[LobbyImage["ProfileSettings"] = 244] = "ProfileSettings";
    // Gifting
    LobbyImage[LobbyImage["StoreGiftMembership"] = 245] = "StoreGiftMembership";
    LobbyImage[LobbyImage["StoreGiftMembershipDark"] = 249] = "StoreGiftMembershipDark";
    // Tournaments
    LobbyImage[LobbyImage["TournamentCC25"] = 283] = "TournamentCC25";
    LobbyImage[LobbyImage["TournamentS11First"] = 257] = "TournamentS11First";
    LobbyImage[LobbyImage["Tournament4P"] = 260] = "Tournament4P";
    // Ads
    LobbyImage[LobbyImage["BannerMember"] = 259] = "BannerMember";
    LobbyImage[LobbyImage["BannerShuffle"] = 282] = "BannerShuffle";
    LobbyImage[LobbyImage["LandscapeDeprecationWarning"] = 268] = "LandscapeDeprecationWarning";
    // Shuffle Icons
    LobbyImage[LobbyImage["IconRotation"] = 271] = "IconRotation";
    LobbyImage[LobbyImage["IconTimer"] = 272] = "IconTimer";
    LobbyImage[LobbyImage["GameModeShuffle"] = 273] = "GameModeShuffle";
    // GameModeShuffleBeta = 274,
    // Beta Icons
    LobbyImage[LobbyImage["IconBeta"] = 275] = "IconBeta";
    // Bot Difficulty Icons
    LobbyImage[LobbyImage["BotBeginner"] = 276] = "BotBeginner";
    LobbyImage[LobbyImage["BotEasy"] = 277] = "BotEasy";
    LobbyImage[LobbyImage["BotMedium"] = 278] = "BotMedium";
    LobbyImage[LobbyImage["BotHard"] = 279] = "BotHard";
    // Ranked Game Mode Icons
    LobbyImage[LobbyImage["GameModeRanked1v1"] = 280] = "GameModeRanked1v1";
    LobbyImage[LobbyImage["GameModeRanked4P"] = 281] = "GameModeRanked4P";
    LobbyImage[LobbyImage["GameModeRankedRush"] = 293] = "GameModeRankedRush";
    LobbyImage[LobbyImage["GameModeBotRush"] = 294] = "GameModeBotRush";
    // Leaderboard
    LobbyImage[LobbyImage["Leaderboard"] = 284] = "Leaderboard";
    // Gift
    LobbyImage[LobbyImage["Gift"] = 287] = "Gift";
    // Portrait Mode Popups
    LobbyImage[LobbyImage["PortraitModeOptIn"] = 290] = "PortraitModeOptIn";
    LobbyImage[LobbyImage["SwitchToPortrait"] = 291] = "SwitchToPortrait";
    // Rush Intro
    LobbyImage[LobbyImage["RushInformation"] = 292] = "RushInformation";
    return LobbyImage;
}({});
// TODO: Membership Check
// Membership Types
// persisted enum, do not delete or change existing entries
export var ColonistMembershipType = /*#__PURE__*/ function(ColonistMembershipType) {
    ColonistMembershipType[ColonistMembershipType["PlusMonthly"] = 0] = "PlusMonthly";
    ColonistMembershipType[ColonistMembershipType["PremiumMonthly"] = 1] = "PremiumMonthly";
    ColonistMembershipType[ColonistMembershipType["EliteMonthly"] = 2] = "EliteMonthly";
    ColonistMembershipType[ColonistMembershipType["PlusYearly"] = 3] = "PlusYearly";
    ColonistMembershipType[ColonistMembershipType["PremiumYearly"] = 4] = "PremiumYearly";
    ColonistMembershipType[ColonistMembershipType["EliteYearly"] = 5] = "EliteYearly";
    ColonistMembershipType[ColonistMembershipType["Holiday2023AllAccessPass"] = 6] = "Holiday2023AllAccessPass";
    return ColonistMembershipType;
}({});
// better memberships have lower values
export const COLONIST_MEMBERSHIP_PRIORITY = {
    [5]: 0,
    [2]: 1,
    [6]: 2,
    [4]: 3,
    [1]: 4,
    [3]: 5,
    [0]: 6
};
// persisted enum, do not delete or change existing entries
export var ColonistOneTimePurchaseType = /*#__PURE__*/ function(ColonistOneTimePurchaseType) {
    ColonistOneTimePurchaseType[ColonistOneTimePurchaseType["Holiday2023AllAccessPass"] = 0] = "Holiday2023AllAccessPass";
    ColonistOneTimePurchaseType[ColonistOneTimePurchaseType["GiftPlusMonthly"] = 1] = "GiftPlusMonthly";
    ColonistOneTimePurchaseType[ColonistOneTimePurchaseType["GiftPremiumMonthly"] = 2] = "GiftPremiumMonthly";
    ColonistOneTimePurchaseType[ColonistOneTimePurchaseType["GiftEliteMonthly"] = 3] = "GiftEliteMonthly";
    ColonistOneTimePurchaseType[ColonistOneTimePurchaseType["GiftPlusYearly"] = 4] = "GiftPlusYearly";
    ColonistOneTimePurchaseType[ColonistOneTimePurchaseType["GiftPremiumYearly"] = 5] = "GiftPremiumYearly";
    ColonistOneTimePurchaseType[ColonistOneTimePurchaseType["GiftEliteYearly"] = 6] = "GiftEliteYearly";
    return ColonistOneTimePurchaseType;
}({});
// Never change or remove existing values, these are saved in the database as integers (ItemEntity.ts)
// Ok to add values to the end
// Ok to rename
export var StoreExpansionType = /*#__PURE__*/ function(StoreExpansionType) {
    StoreExpansionType[StoreExpansionType["Seafarers4P"] = 0] = "Seafarers4P";
    StoreExpansionType[StoreExpansionType["CitiesAndKnights4P"] = 1] = "CitiesAndKnights4P";
    StoreExpansionType[StoreExpansionType["TradersAndBarbarians"] = 2] = "TradersAndBarbarians";
    StoreExpansionType[StoreExpansionType["ExplorersAndPirates"] = 3] = "ExplorersAndPirates";
    StoreExpansionType[StoreExpansionType["Classic56P"] = 4] = "Classic56P";
    StoreExpansionType[StoreExpansionType["Classic78P"] = 5] = "Classic78P";
    StoreExpansionType[StoreExpansionType["Seafarers56P"] = 6] = "Seafarers56P";
    StoreExpansionType[StoreExpansionType["CitiesAndKnights56P"] = 7] = "CitiesAndKnights56P";
    StoreExpansionType[StoreExpansionType["CitiesAndKnightsSeafarers4P"] = 8] = "CitiesAndKnightsSeafarers4P";
    StoreExpansionType[StoreExpansionType["CitiesAndKnightsSeafarers56P"] = 9] = "CitiesAndKnightsSeafarers56P";
    StoreExpansionType[StoreExpansionType["ColonistRush4P"] = 10] = "ColonistRush4P";
    return StoreExpansionType;
}({});
